import {useState} from "react";
import styled from "@emotion/styled";
import {Button} from "@kaltura/ds-react-components";
import {Share24Icon} from "@kaltura/ds-react-icons";
import {ShareProps, ShareModal} from "./modal/ShareModal";
import {alpha} from "@mediaspace/shared/styled";
import {ButtonClickAnalyticsType} from "@mediaspace/shared/types/ButtonClickAnalyticsType";
import {useButtonAnalytics} from "@mediaspace/hooks";

const StyledButton = styled(Button, {
    shouldForwardProp: prop => prop !== 'isHeroAction'
})<{ isHeroAction?: boolean } >(({theme, isHeroAction}) => ({
    minWidth: "fit-content",
    color: theme.kaltura.palette.tone1,
    ...(isHeroAction && {
        color: theme.palette.common.white,
        "&:hover": {
            color: theme.palette.common.white,
            backgroundColor: alpha(theme.palette.common.black, 0.7)
        }
    })
}));

/**
 * Share Component
 */
export const Share = (props: ShareProps) => {

    const {isHeroAction = false, size, title} = props;

    const [openModal, setOpenModal] = useState(false);

    const sendButtonAnalytics = useButtonAnalytics();

    const onButtonClick = (openModal: boolean, action: string, buttonType: number) => {
        const location = isHeroAction ? "Hero" : "Share";
        sendButtonAnalytics(`Media ${location} - ${isHeroAction ? "Share" : action}`, buttonType);
        setOpenModal(openModal);
    }

    return (
        <>
            <StyledButton
                id={"kms-ds-share-button"}
                variant={"borderless"}
                aria-haspopup={true}
                aria-expanded={openModal}
                aria-controls={"kms-ds-share-modal"}
                onClick={() => onButtonClick(true, "Open", ButtonClickAnalyticsType.SHARE)}
                startIcon={<Share24Icon />}
                color={"secondary"}
                isHeroAction={isHeroAction}
                size={isHeroAction ? size : "medium"}
            >
                {title}
            </StyledButton>
            <ShareModal
                modalID={"kms-ds-share-modal"}
                open={openModal}
                onClose={() => {
                    onButtonClick(false, "Close", ButtonClickAnalyticsType.CLOSE);
                }}
                {...props}
            ></ShareModal>
        </>
    );
};

export default Share;
